import React, { useCallback, useEffect, useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import Paginador, { PaginationProvider } from 'react-bootstrap-table2-paginator'
import { useSelector } from 'react-redux'

import { api_gateway } from '../../../conexoes/api'
import { useGlobal } from '../../../stores/useGlobal'
import { lixeiraVermelho } from '../../../utils/alternanciaIcones'
import decryptJWT from '../../../utils/decryptJWT'
import { formatarData } from '../../../utils/formatadorDataTabela'
import PaguinacaoTabela from '../../../utils/paginacaoTabela'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'
import Botao from '../../Mantine/Botao'
import Modal from '../../Mantine/Modal'
import SpinnerVeye from '../../spinnerVeye/spinnerVeye'

import * as S from './styles'
import MensagemAtencao from '../../componentesModais/mensagens/mensagemAtencao'

const valorLimite = 50
let totalPaginas = 0
let totalItens = 0
let contador = 0
let controladorPagina = 1
let itensVar = []

const routeM1FiltrarSimcard = '/m1/filtrar/simcard'

const ALERTAS = {
  padrao: { open: false, mensagem: '' },
  maximo: {
    titulo: 'Atenção!',
    open: true,
    mensagem: 'O máximo permitido para essa ação é de 100 linhas selecionadas.'
  },
  sucesso: { open: true, isSuccess: true }
}

const LIMITE_DE_LINHAS = 100

export default function DestravarImei({
  itensSelecionados,
  ordenador,
  renderizar,
  setRenderizar
}) {
  const { setMostrarAcao, setMostrarNotificacao } = useGlobal()
  const [spinAtivo, setSpinAtivo] = useState(true)

  const [paginaAtual, setPaginaAtual] = useState(1)
  const [itens, setItens] = useState([])
  const [linhaRemover, setLinhaRemover] = useState('')
  const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)
  const [quantidadeLinhasSelecionados, setQuantidadeLinhasSelecionados] =
    useState(-1)
  const [alerta, setAlerta] = useState(ALERTAS.padrao)

  let itensTemp = []

  let filtros = useSelector((state) => state.filtrosState.filtros)
  let buscaArquivo = useSelector(
    (state) => state.buscaArquivoState.buscaArquivo
  )
  let modoSelecaoSimcard = useSelector(
    (state) => state.manejadorState.modoSelecaoSimcard
  )
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let separadorLinha = useSelector(
    (state) => state.manejadorState.separadorLinha
  )

  const colunas = [
    {
      dataField: 'CD_SIMCARD',
      text: 'Código',
      headerClasses: 'nao-selecionavel',
      hidden: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'CALLERID',
      headerClasses: 'nao-selecionavel',
      text: 'Linha',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'ICCID',
      headerClasses: 'nao-selecionavel',
      text: 'ICCID',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'IMEI_VERIFICADOR',
      headerClasses: 'nao-selecionavel',
      text: 'IMEI',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'OPERADORA',
      text: 'Operadora',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'ULTIMO_EVENTO',
      headerClasses: 'nao-selecionavel',
      text: 'Último evento',
      sort: true,
      style: {
        paddingLeft: '0px'
      },
      formatter: (cell) => {
        if (cell) {
          cell = cell.replace('T', ' ').split('.')
          if (cell.length > 0) {
            cell = cell[0]
          }
        }
        return formatarData(cell)
      }
    },
    {
      dataField: 'acoes',
      text: '',
      sort: false,
      headerClasses: 'tabela-coluna-ultima-header nao-selecionavel',
      formatter: () => {
        return (
          <S.ButtonDeletar onClick={() => setRevelarMensagemAtencao(true)}>
            <S.ImgDeletar src={lixeiraVermelho()} alt="remover-linha" />
          </S.ButtonDeletar>
        )
      }
    }
  ]

  const atualizarSimcards = useCallback(() => {
    if (itensSelecionados?.length > LIMITE_DE_LINHAS) {
      setAlerta(ALERTAS.maximo)
      return
    }
  }, [itensSelecionados])

  useEffect(() => {
    if (itensSelecionados?.length > 0) {
      atualizarSimcards()
    }
  }, [itensSelecionados, atualizarSimcards])

  useEffect(() => {
    if (itensSelecionados && itensSelecionados.length > 0) {
      totalItens = itensSelecionados.length
      totalPaginas = Math.ceil(totalItens / valorLimite)

      setItens([...itensSelecionados])
      setQuantidadeLinhasSelecionados(totalItens)
      setSpinAtivo(false)
    }
  }, [itensSelecionados, paginaAtual])

  useEffect(() => {
    if (!itensSelecionados || itensSelecionados.length === 0) {
      if (modoSelecaoSimcard) {
        handlerConsultarSimcads()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginaAtual, modoSelecaoSimcard])

  async function handlerConsultarSimcads() {
    setSpinAtivo(true)
    if (totalPaginas === 0) {
      contador = 0
      itensVar = []
      setItens([])
      const countItens = await contarItens()

      if (countItens > LIMITE_DE_LINHAS) {
        setAlerta(ALERTAS.maximo)

        return
      }
    } else {
      contador = (paginaAtual - 1) * valorLimite
    }

    if (controladorPagina <= paginaAtual) {
      const params = {
        paguinaAtual: contador,
        carregarLimit: valorLimite,
        acao: true,
        buscar: conteudoBusca,
        ordenador: ordenador,
        filtros: JSON.stringify(filtros),
        buscaArquivo: JSON.stringify(buscaArquivo),
        separador: separadorLinha,
        contar: false,
        cd_pav_usuario: decryptJWT('codigo')
      }

      const consultaSimcards = await api_gateway
        .get(routeM1FiltrarSimcard, { params })
        .then(function (resposta) {
          return resposta.data.dados
        })
        .catch(function (erro) {
          throw erro
        })

      inserirData(consultaSimcards)
      setSpinAtivo(false)
    }
  }

  async function contarItens() {
    let arrayItens = []
    let apiData = []

    if (controladorPagina <= paginaAtual) {
      const params = {
        acao: true,
        buscar: conteudoBusca,
        filtros: JSON.stringify(filtros),
        buscaArquivo: JSON.stringify(buscaArquivo),
        separador: separadorLinha,
        contar: true
      }

      apiData = await api_gateway
        .get(routeM1FiltrarSimcard, { params })
        .then(function (resposta) {
          return resposta
        })
        .catch(function (erro) {
          throw erro
        })
    }

    setQuantidadeLinhasSelecionados(apiData.data.dados[0].CONTADOR)

    totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
    totalItens = apiData.data.dados[0].CONTADOR
    arrayItens = Array.from({ length: totalItens }, (_, i) => i)
    itensVar = arrayItens

    return apiData.data.dados[0].CONTADOR
  }

  function inserirData(data) {
    if (itensVar.length == totalItens) {
      for (let i = 0; i < totalItens; i++) {
        if (contador === i) {
          let k = i
          for (let j = 0; j < data.length; j++) {
            itensVar[k] = data[j]
            k++
          }
        }
        if (i == totalItens - 1) {
          itensTemp = JSON.parse(JSON.stringify(itensVar))
          setItens(JSON.parse(JSON.stringify(itensVar)))
        }
      }
    }
  }

  function handleMensagemAtencao(confirmacao) {
    if (revelarMensagemAtencao === false) {
      setRevelarMensagemAtencao(true)
    } else {
      setRevelarMensagemAtencao(false)
      if (confirmacao === true) {
        handleRemoverLinha(linhaRemover)
      }
    }
  }

  async function handleRemoverLinha(CD_SIMCARD) {
    setRevelarMensagemAtencao(false)
    if (modoSelecaoSimcard) {
      for (let i = contador; i < itensSelecionados.length; i++) {
        if (itensSelecionados[i] == CD_SIMCARD) {
          itensSelecionados.splice(i, 1)
        }
      }

      await Promise.all(
        itensVar.map((item_itensVar, i) => {
          if (CD_SIMCARD == item_itensVar.CD_SIMCARD) {
            itensVar.splice(i, 1)
          }
        })
      )
      await contarItens()
      setItens(itensVar)
    } else {
      itensTemp = itens
      itens.forEach((e, index) => {
        if (CD_SIMCARD == e.CD_SIMCARD) {
          itens.splice(index, 1)
        }
      })

      setItens(itensTemp)
    }

    setQuantidadeLinhasSelecionados(itensTemp.length)

    if (itensTemp.length === 0) {
      handleClose()
    }
  }

  const opcoesPaginacao = {
    page: paginaAtual,
    showTotal: true,
    sizePerPage: valorLimite,
    firstPageTitle: 'Primeira',
    lastPageTitle: 'Última',
    nextPageTitle: 'Proxima',
    prePageTitle: 'Anterior',
    custom: true,
    onPageChange: (page) => {
      setPaginaAtual(page)
    }
  }

  const eventosLinhas = {
    onClick: (e, row) => {
      setLinhaRemover(row.CD_SIMCARD)
    }
  }

  const handleClose = () => {
    setMostrarAcao(undefined)

    totalItens = 0
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    itensVar = []
  }

  function handleMensagemSucesso() {
    handleClose()
    setRenderizar(!renderizar)
  }

  const handleSubmit = async () => {
    setSpinAtivo(true)

    const formattedLinhas = itens.map((item) => item.FULLCALLERID)
    const formattedCdSimcads = itens.map((item) => item.CD_SIMCARD)

    let tempLinhas = [...formattedLinhas]
    let tempCdSimcads = [...formattedCdSimcads]

    const executarDelete = () => {
      api_gateway
        .delete('/api/v2/imeiManagement/unbindImei', {
          data: {
            subscriberNumber: tempLinhas,
            subscriberId: tempCdSimcads
          }
        })
        .then(() => setAlerta(ALERTAS.sucesso))
        .catch(() =>
          setMostrarNotificacao({
            show: true,
            type: 'error',
            title: 'Falha ao destravar IMEI',
            message: 'Não foi possível destravar IMEI, tente novamente.'
          })
        )
        .finally(() => setSpinAtivo(false))
    }

    if (modoSelecaoSimcard) {
      const params = {
        acao: true,
        buscar: conteudoBusca,
        filtros: JSON.stringify(filtros),
        buscaArquivo: JSON.stringify(buscaArquivo),
        separador: separadorLinha,
        contar: false
      }

      api_gateway
        .get(routeM1FiltrarSimcard, { params })
        .then((resposta) => {
          const consultaSimcards = resposta.data

          if (
            consultaSimcards.status === 200 &&
            consultaSimcards.dados.length > 0
          ) {
            consultaSimcards.dados.forEach((item) => {
              tempLinhas.push(item.FULLCALLERID)
              tempCdSimcads.push(item.CD_SIMCARD)
            })
          }

          executarDelete()
        })
        .catch((erro) => {
          setMostrarNotificacao({
            show: true,
            type: 'error',
            title: 'Falha ao destravar IMEI',
            message: 'Não foi possível destravar IMEI, tente novamente.'
          })
          setSpinAtivo(false)

          throw erro
        })

      return
    }

    executarDelete()
  }

  return (
    <>
      <Modal
        width="850px"
        titulo="Destravar IMEI"
        opened={!alerta.open}
        close={handleClose}
        onConfirm={handleSubmit}
      >
        <>
          {spinAtivo && (
            <div className="componente-spinner-overlay">
              <div className="componente-spinner-container">
                <SpinnerVeye />
              </div>
            </div>
          )}

          <S.TabelaWrapper>
            <div className="container-tabela-modal">
              <PaginationProvider pagination={Paginador(opcoesPaginacao)}>
                {({ paginationProps, paginationTableProps }) => (
                  <>
                    <BootstrapTable
                      classes="tabela-transparente-modais"
                      condensed
                      keyField="id"
                      data={itens}
                      columns={colunas}
                      rowEvents={eventosLinhas}
                      noDataIndication="Nenhum item encontrado"
                      bootstrap4
                      {...paginationTableProps}
                    />
                    {(modoSelecaoSimcard || itensSelecionados.length > 50) && (
                      <S.PaginacaoTabela>
                        <PaguinacaoTabela
                          extrato
                          setPaginaAtual={setPaginaAtual}
                          totalPaginas={totalPaginas}
                          totalItens={totalItens}
                          valorLimite={valorLimite}
                          paginaAtual={paginaAtual}
                          page={paginationProps.page}
                          onPageChange={paginationProps.onPageChange}
                        />
                      </S.PaginacaoTabela>
                    )}
                  </>
                )}
              </PaginationProvider>
            </div>
            <S.QuantidadeLinhas>
              {quantidadeLinhasSelecionados} linhas selecionadas
            </S.QuantidadeLinhas>

            {revelarMensagemAtencao && (
              <div className="componente-modal-overlay">
                <div className="componente-modal">
                  <MensagemAtencao
                    handleMensagemAtencao={handleMensagemAtencao}
                    mensagemTitulo="Remover linha?"
                    mensagemBotao="Remover"
                  />
                </div>
              </div>
            )}
          </S.TabelaWrapper>
        </>
      </Modal>

      {alerta.open && !alerta.isSuccess && (
        <Modal
          opened={alerta.open}
          width="400px"
          minHeight="180px"
          type="alerta"
        >
          <S.ContainerAlerta>
            {alerta.titulo && <S.TituloAlerta>{alerta.titulo}</S.TituloAlerta>}
            <S.MensagemAlerta>{alerta.mensagem}</S.MensagemAlerta>
            <Botao label="Fechar" onClick={handleClose} />
          </S.ContainerAlerta>
        </Modal>
      )}

      {alerta.open && alerta.isSuccess && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1="Sua solicitação foi enviada com sucesso"
              mensagemBotao="Continuar"
            />
          </div>
        </div>
      )}
    </>
  )
}
